import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import classNames from 'classnames';
import {execBI} from '../services/bi-events-manager';
import {popupHide} from '../actions/popup';
import _ from 'lodash';
import ALink from './ALink';

class CategoriesMenuTemp extends React.Component {

  linkClick(slug) {
    return () => {
      execBI('CATEGORY_LINK_CLICK', {category: slug, origin: 'menu'});
    };
  }

  /**
   * Close popup when clicking on link or outside menu
   * Can't use regular overlay behind because we need interactive elements outside
   */
  componentWillUpdate(nextProps) {
    if (nextProps.isVisible && this.props.isVisible !== nextProps.isVisible) {
      const root = document.getElementById('app-market');

      const closeMenu = (ev) => {
        const findTarget = (el) => {
          if (['A', 'INPUT', 'BUTTON'].indexOf(el.tagName) !== -1 || el === root) {
            root.removeEventListener('click', closeMenu);

            if (el.id !== 'app-market-categories-button') {
              this.props.dispatch(popupHide());
            }

          } else if (el !== this.container) {
            findTarget(el.parentElement);
          }
        };

        findTarget(ev.target);
      };

      root.addEventListener('click', closeMenu);
    }
  }

  render() {
    const openCategory = this.props.openCategory;
    const categories = this.props.categories;
    const addCategory = (slug, list) => {
      const c = _.find(categories, (c) => c.slug === slug);
      if (c) {
        list.push(c);
      }
    };

    const catB = [
      {slug: 'all', name: this.props.intl.formatMessage({id: 'category.all.name'})},
      {slug: 'new', name: this.props.intl.formatMessage({id: 'category.new.name'})},
      {slug: 'popular', name: this.props.intl.formatMessage({id: 'category.popular.name'})},
    ];
    addCategory('free-apps', catB);
    addCategory('made-by-wix', catB);

    const catA = [];
    addCategory('online-store', catA);
    catA.push({slug: 'business', name: this.props.intl.formatMessage({id: 'category.business.name'})});
    addCategory('social', catA);
    addCategory('forms', catA);
    addCategory('galleries', catA);
    addCategory('marketing-tools-3', catA);

    return (
      <div className={classNames('categories-menu-container', {'categories-menu-visible': this.props.isVisible})}>
        <div className={classNames('categories-menu', {'categories-menu-no-my-apps': true})} ref={i => this.container = i}>
          <div className="categories-menu-wrapper">
            <div className="categories-menu-flex">

              <div className="category-1-4">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.general.categories"/></h4>
                <ul className="category-list">
                  {catA.map((c) =>
                    <li key={c.slug} className={classNames('category-item', 'typography_t2', {'selected': c.slug === openCategory})}>
                      <ALink to={`/${c.slug}/`} onClick={this.linkClick(c.slug)}>{c.name}</ALink>
                    </li>
                  )}
                </ul>
              </div>


              <div className="category-1-4">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.browse.apps"/></h4>
                <ul className="category-list">
                  {catB.map((c) =>
                    <li key={c.slug} className={classNames('category-item', 'typography_t2', {'selected': c.slug === openCategory})}>
                      <ALink to={`/${c.slug}/`} onClick={this.linkClick(c.slug)}>{c.name}</ALink>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className={classNames('categories-menu-main-page typography_t2', {'selected': openCategory === 'main'})}>
              <ALink to={'/main'} onClick={this.linkClick('main-page')}><FormattedMessage id="category.main.name"/></ALink>
            </div>

          </div>
        </div>

      </div>
    );
  }

  static propTypes = {
    categories: PropTypes.array,
    developer: PropTypes.array,
    pending: PropTypes.array,
    isVisible: PropTypes.bool,
    dispatch: PropTypes.func,
    openCategory: PropTypes.string,
    intl: intlShape
  };
}

function mapStateToProps(state) {
  return {
    categories: state.categories.menu.items,
    developer: state.appsByType.developer.items,
    pending: state.appsByType.pendingInMarket.items,
    openCategory: state.categories.openCategory,
    isVisible: state.popup.type === 'menu'
  };
}

export default connect(mapStateToProps)(injectIntl(CategoriesMenuTemp));



// WEBPACK FOOTER //
// ./components/Categories-menu-temp.js